import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ITreeViewComponent from '@components/FormFlow/Interfaces/FormflowComponents/ITreeViewComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import ITreeViewItem from '@interfaces/ITreeViewItem';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { InstructionTaskComponent } from '../TextInstructionComponent';
import TreeViewComponent from '../TreeView/TreeViewComponent';

interface ISelectTaskComponentStateType {
    instructionTitle: string;
    required: boolean;
    description?: string;
    newOrExistingItemList?: string;
    // selectList: any[];
    multiple: boolean;
    conditionsTaskComponents: boolean;
    treeViewItems: ITreeViewItem[];
};

export class SelectTreeComponent implements ITreeViewComponent {
    id: string;
    required: boolean;
    type: ComponentType;
    title: string;
    description?: string;
    entityAPI: string;
    items: ITreeViewItem[];
    multiple: boolean;
    minMultiple: number;
    maxMultiple: number;
    depth: number;
    value: string;
    weight: number;
    repeat: boolean;
    minRepeat: number;
    maxRepeat: number;

    constructor(id: string = '') {
        this.id = id;
        this.required = false;
        this.type = ComponentType.TREEVIEW;
        this.title = '';
        this.entityAPI = '';
        this.items = []
        this.depth = 0;
        this.value = '';
        this.weight = 0;
        this.repeat = false;
        this.multiple = false;
        this.minMultiple = 0;
        this.maxMultiple = 0;
        this.minRepeat = 0;
        this.maxRepeat = 0;

        return this;
    }
}

export default class SelectTreeViewComponent extends React.Component<ITreeViewComponent, ISelectTaskComponentStateType> {
    private treeRef: any;

    constructor(props: ITreeViewComponent) {
        super(props);
        this.state = {
            instructionTitle: '',
            description: this.props.description,
            required: this.props.required || false,
            newOrExistingItemList: '', //FIXME: não deixar esse valor como inicial
            multiple: this.props.multiple || false,
            conditionsTaskComponents: true,
            treeViewItems: [],
        };

        this.treeViewUpdated = this.treeViewUpdated.bind(this);
        this.getTreeData = this.getTreeData.bind(this);
        this.validateTreeData = this.validateTreeData.bind(this);
        this.handleMultipleChange = this.handleMultipleChange.bind(this);
        this.treeRef = React.createRef();

    }

    componentDidMount() {
        this.setState({ 
            instructionTitle: this.props.title  ? this.props.title  : '',
            treeViewItems: this.props.items
        })
    }

    

    handleIntructionTitleChange = async (evt: any) => {
        this.setState({ instructionTitle: evt.target.value });
    }
    handleDescriptionChange = async (evt: any) => {
        this.setState({ description: evt.target.value });
    }


    handleRequiredChange = async (evt: any) => {
        this.setState({ required: evt.target.checked });
    }
    handleMultipleChange = async (evt: any) => {
        this.setState({ multiple: evt.target.value });
    }
    onChangeRadioNewOrExistingList = async (evt: any) => {
        this.setState({ newOrExistingItemList: evt.target.value })
        if (this.state.newOrExistingItemList === 'new')
            this.setState({ conditionsTaskComponents: true })
        else if (this.state.newOrExistingItemList === 'existing')
            this.setState({ conditionsTaskComponents: false })
    }
    handleInputItemChange = (idx: any) => (evt: any) => {
        const newSelectList = this.state.treeViewItems.map((selectListItems, sidx) => {
            if (idx !== sidx) return selectListItems;
            return { ...selectListItems, value: evt.target.value };
        });

        this.setState({ treeViewItems: newSelectList });

    }
    handleInputScoreChange = (idx: any) => (evt: any) => {
        const newSelectListScore = this.state.treeViewItems.map((selectListScore, sidx) => {
            if (idx !== sidx) return selectListScore;
            return { ...selectListScore, weight: evt };
        });
        this.setState({ treeViewItems: newSelectListScore });
    }

    onSubmitTreeViewComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
        let treeData: ITreeViewItem[] = []; 
        if(this.validateTreeData() === false){            
            console.log("TREE VALIDATION NOT OK");
            return;
        }
        treeData = this.getTreeData();

        const newTextDataComponent = {
            id: this.props.id,
            type: ComponentType.TREEVIEW,
            title: this.state.instructionTitle,
            multiple: this.state.multiple,
            description: this.state.description,
            required: this.state.required,
            items: treeData,
        }

        updateFormflowWithComponent(newTextDataComponent);
    }

    treeViewUpdated(treeViewItems: ITreeViewItem[]) {
        this.setState({ treeViewItems: treeViewItems });
    }

    validateTreeData() {
        const validateOk = this.treeRef.current.validateData();
        return validateOk;
    }

    getTreeData() {
        const data = this.treeRef.current.getTreeData();
        return data;
    }

    render() {
        const {
            newOrExistingItemList,
            conditionsTaskComponents,
            instructionTitle,

        } = this.state;

        return (
            <Wrapper>
                <InstructionTaskComponent
                    visibleDescription={false}
                    inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
                    ItemList={newOrExistingItemList}
                    inputTitleValue={instructionTitle}
                    requiredCheckedValue={this.state.required}
                    valueRadioSelect={newOrExistingItemList}
                    onInputInstructionChange={() => this.handleIntructionTitleChange}
                    onChangeDescription={() => this.handleDescriptionChange}
                    onChangeRequiredCheckbox={() => this.handleRequiredChange}
                    titleComponent={I18n.l("formflow.components.treeViewComponent.title")}
                    descriptionComponent={I18n.l("formflow.components.treeViewComponent.description")}
                    exampleDescriptionComponent={I18n.l("formflow.components.treeViewComponent.exampleDescription")}
                    radioOnlyOneOrMultipleItemList={true}
                    titleRadioOnlyOneItemList={I18n.l("formflow.components.selectComponent.titleRadioOnlyOneItemList")}
                    titleRadioMultipleItemList={I18n.l("formflow.components.selectComponent.titleRadioMultipleItemList")}
                    onChangeRadioNewOrExistingList={this.onChangeRadioNewOrExistingList}
                    conditionsTaskComponents={conditionsTaskComponents}
                    valueRadioItemList={this.state.multiple}
                    onChangeRadioMultipleItemList={this.handleMultipleChange}
                />
                    <div>
                        <DividerBorder />
                        <Row style={{ marginTop: '10px', marginLeft: '55px' }}>
                            <TreeViewComponent
                                data={this.state.treeViewItems}
                                onChangeTree={this.treeViewUpdated}
                                ref={this.treeRef}
                            />
                        </Row>
                    </div>

                <FormflowContext.Consumer>
                    {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
                        <div>
                            <ButtonSaveStyle>
                                <Row type="flex" justify="end">
                                    <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                                    <Button className="button-save" type="primary" disabled={instructionTitle.length === 0 ? true : false} onClick={() => { this.onSubmitTreeViewComponent(updateFormflowWithComponent) }} >{I18n.l('common.save')}</Button>
                                </Row>
                            </ButtonSaveStyle>
                        </div>
                    )}
                </FormflowContext.Consumer>
            </Wrapper>
        );
    }
}
const Wrapper = styled.div`
    width:100%;
    margin-bottom: 10rem;
    .optional-validation-condition-text{
        font-weight: bold;
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-checkbox-validation{
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-input-validation{
        width: 70px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
    }
    .input-item-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .input-score-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 100%;
    }
    .delete-style{
        margin-top: 2rem;
    }
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }

`

const DividerBorder = styled.div`
    margin-top: 2rem;
    margin-left: 3rem;
    margin-right: 3rem;   
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`

const ButtonSaveStyle = styled.div`
    float:right;
    margin-top: 5vh;
    margin-bottom: 5vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;